import React from "react";
import { Input } from "reactstrap";
import {
  getScreenConnectionLabel,
  IScreenStatus,
} from "../../app/models/screens";

interface IParams {
  screen: IScreenStatus;
  onLabelChange: (label: string) => void;
}

export const LabelEditingModal: React.FC<IParams> = ({
  screen,
  onLabelChange,
}) => {
  return (
    <Input
      defaultValue={getScreenConnectionLabel(screen)}
      onChange={(e) => onLabelChange(e.currentTarget.value)}
    ></Input>
  );
};

export default LabelEditingModal;
